<template>
  <div>
    <div class="lftj_title">来自区域情况统计</div>
    <div class="lftj_search">
      <span style="font-size:13px;font-weight:bold;">统计时段：</span>
      <el-radio-group v-model="selectItem" size="mini" @change="select()">
        <el-radio :label="1">本周</el-radio>
        <el-radio :label="2">本月</el-radio>
        <el-radio :label="3">本季</el-radio>
        <el-radio :label="4">本年</el-radio>
        <el-radio :label="5">其他</el-radio>
      </el-radio-group>
      <el-date-picker
        v-model="searchDate"
        type="daterange"
        size="mini"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width:200px; margin-right:10px;"
        :disabled="disabled"
      ></el-date-picker>
      <el-button type="primary" size="mini" @click="getListData()">统计</el-button>
      <el-button type="primary" size="mini" v-show="false">导出</el-button>
    </div>
    <div>
      <el-table
        :data="tableData"
        style="width:70%;margin: 20px auto;"
        row-key="来自区域"
        border
        default-expand-all="true"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column
          v-for="(item,index) in columnData"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getVisitorListCount } from "@/api/api";
export default {
  data() {
    return {
      user: {},
      selectItem: 1, //当前选择的tip
      disabled: true, //是否显示统计时间
      searchDate: "", //查询时间
      columnData: [
        {
          label: "来自区域",
          prop: "来自区域"
        },
        {
          label: "受访次数",
          prop: "受访次数"
        },
        {
          label: "来访人数",
          prop: "来访人数"
        }
      ],
      tableData: [
        {
          来自区域: "湖南",
          受访次数: 1,
          来访人数: 3,
          children: [
            { 来自区域: "长沙", 受访次数: 4, 来访人数: 14 },
            { 来自区域: "湘潭", 受访次数: 5, 来访人数: 20 }
          ]
        },
        {
          来自区域: "四川",
          受访次数: 2,
          来访人数: 4,
          children: [{ 来自区域: "成都", 受访次数: 4, 来访人数: 14 }]
        },
        {
          来自区域: "广东",
          受访次数: 3,
          来访人数: 48,
          children: [
            { 来自区域: "广州", 受访次数: 4, 来访人数: 14 },
            { 来自区域: "深圳", 受访次数: 5, 来访人数: 20 }
          ]
        }
      ]
    };
  },
   mounted() {
    this.user = JSON.parse(window.localStorage.user);
    this.getListData();
  },

  methods: {
     //查询列表
    getListData() {
      this.tableData=[];
      var _this = this;
      var para = {
        params: {
          companyId: this.user.companyId,
          queryBy: 2,
          queryType : this.selectItem,
          startTime: this.searchDate[0],
          endTime: this.searchDate[1]
        }
      };
      getVisitorListCount(para).then(res => {
        var data = JSON.parse(res.data);
        if (data.Success) {
          var list = data.Data;
          if (list.length > 0) {
            list.forEach(element => {
              var model={
                来自区域:element.VisitorProvinceCode,
                受访次数: element.CountVisit===null?0:element.CountVisit,
                来访人数: element.VisitsNumber===null?0:element.VisitsNumber,
                children:[]
              }
              element.lstCity.forEach(elByclild => {
                model.children.push({
                  来自区域:elByclild.VisitorCityCode,
                   受访次数: elByclild.CountCityVisit===null?0:elByclild.CountCityVisit,
                 来访人数: elByclild.CityVisitsNumber===null?0:elByclild.CityVisitsNumber,
                })
              });
               _this.tableData.push(model);
            });
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    select() {
      this.disabled = true;
      if (this.selectItem === 5) {
        this.disabled = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/fksys/lftj/lzqy.vue